import React from 'react';
import { useAuth } from '@/lib/supabase-auth';
import { useClarity } from '@/hooks/useClarity';

interface ClarityProviderProps {
  children: React.ReactNode;
}

/**
 * Componente provider para inicializar o Microsoft Clarity
 */
export const ClarityProvider: React.FC<ClarityProviderProps> = ({ children }) => {
  const { user, isAuthenticated } = useAuth();

  // Configuração do Clarity baseada nas variáveis de ambiente
  const clarityConfig = {
    projectId: import.meta.env.VITE_CLARITY_PROJECT_ID,
    enabled: import.meta.env.VITE_CLARITY_ENABLED === 'true',
    userId: isAuthenticated && user ? user.id : undefined,
    userRole: isAuthenticated && user ? user.papel : undefined,
    userName: isAuthenticated && user ? user.nome : undefined,
  };

  // Inicializar o Clarity
  const clarity = useClarity(clarityConfig);

  // Log da configuração em desenvolvimento
  if (import.meta.env.DEV) {
    console.log('🔍 Clarity Configuration:', {
      projectId: clarityConfig.projectId ? '***' : 'não configurado',
      enabled: clarityConfig.enabled,
      userAuthenticated: isAuthenticated,
      userRole: clarityConfig.userRole,
    });
  }

  return <>{children}</>;
};